function production() {
    return process.env.NODE_ENV === 'production';
}

function home() {
    return document.body.classList.contains('home');
}

export { production, home };
